import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'

const MusicPlayer = () => {
  return (
    <div className="music-page">

      {/* Header */}
      <nav className="navbar navbar-expand-lg navbar-dark custom-navbar px-3 px-lg-5">
        <div className="container-fluid">

          <a
            className="navbar-brand d-flex align-items-center gap-3"
            href="/"
          >
            <img
              src="../images/icon/icon3.png"
              alt="Music Player"
              className="music-logo"
            />

            <div>
              <h2 className="brand-title mb-0">
                Music Player
              </h2>

              <p className="brand-subtitle mb-0">
                Offline Audio Experience
              </p>
            </div>
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarContent"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className="collapse navbar-collapse justify-content-end"
            id="navbarContent"
          >
            <ul className="navbar-nav gap-lg-4 text-center mt-4 mt-lg-0">

              <li className="nav-item">
                <a className="nav-link custom-link" href="/">
                  Home
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link custom-link" href="/">
                  Privacy
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link custom-link" href="/">
                  Contact
                </a>
              </li>

            </ul>
          </div>
        </div>
      </nav>

      {/* Empty Body */}
      <main className="body-section">
        <div className="container text-center">

          <div className="empty-body-box">

            <img
              src="../images/icon/icon3.png"
              alt="Music"
              className="body-logo"
            />

            <h1 className="body-title">
              Music Player - Privacy Policy
            </h1>

            <p className="body-text">
              Your privacy is important to us. This Music Player application
              does not collect, store, share, or transmit any personal
              information, sensitive data, or user activity from your device.
              We believe in providing a simple, secure, and privacy-friendly
              music experience for all users.

              The application only requests storage permission so it can scan,
              access, and play audio files that already exist on your device.
              This permission is required for core music playback features such
              as displaying songs, albums, artists, playlists, and allowing
              offline music playback functionality. Without storage permission,
              the application may not be able to detect or play local music
              files available on your device.

              All music files remain stored locally on your device and are never
              uploaded to any server, cloud storage, or third-party platform by
              this application. We do not collect your contact information,
              phone number, email address, location, passwords, payment details,
              or browsing activity. The application also does not track your
              listening habits, usage patterns, or personal preferences for any
              advertising or marketing purposes.

              This app does not use intrusive background tracking technologies
              or hidden analytics systems to monitor user behavior. Any data
              related to your music library stays completely under your control
              on your personal device. We do not sell, rent, or share user data
              with advertisers, analytics companies, or external organizations.

              Our goal is to provide a lightweight and secure offline music
              player experience focused entirely on audio playback and user
              convenience. By using this application, you can enjoy your music
              collection with confidence knowing that your privacy is respected
              and protected.

              If future updates introduce new features requiring additional
              permissions, users will always be informed clearly before granting
              access. Continued use of the application means you agree to this
              privacy policy and understand how permissions are used solely for
              music playback functionality.
            </p>

          </div>

        </div>
      </main>

      {/* Footer */}
      <footer className="footer-section">
        <div className="container">

          <div className="row gy-5">

            <div className="col-lg-4">

              <div className="d-flex align-items-center gap-3 mb-4">

                <img
                  src="../images/icon/icon3.png"
                  alt="Logo"
                  className="footer-logo"
                />

                <div>
                  <h3 className="footer-title mb-1">
                    Music Player
                  </h3>

                  <p className="footer-subtitle mb-0">
                    Offline Audio App
                  </p>
                </div>
              </div>

              <p className="footer-description">
                Enjoy a smooth and modern offline music experience
                with beautiful audio playback support.
              </p>

            </div>

            <div className="col-lg-4">

              <h4 className="footer-heading">
                Quick Links
              </h4>

              <ul className="footer-links">

                <li>
                  <a href="/">Home</a>
                </li>

                <li>
                  <a href="/">Privacy Policy</a>
                </li>

                <li>
                  <a href="/">Support</a>
                </li>

              </ul>

            </div>

            <div className="col-lg-4">

              <h4 className="footer-heading">
                Contact
              </h4>

              <ul className="footer-contact">

                <li>Email: newrahulgautam@gmail.com</li>

                <li>Phone: +91 987XXXX210-PreferMail</li>

                <li>India</li>

              </ul>

            </div>

          </div>

          <div className="copyright-area">
            © 2026 Music Player. All Rights Reserved.
          </div>

        </div>
      </footer>

      {/* CSS */}
      <style>{`

        :root {
          --bg-color: #0f172a;
          --card-color: #111827;
          --border-color: #1e293b;
          --text-color: #ffffff;
          --secondary-text: #94a3b8;
          --accent-color: #06b6d4;
          --hover-color: #0891b2;
        }

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          background: var(--bg-color);
        }

        .music-page {
          min-height: 100vh;
          background: var(--bg-color);
          color: var(--text-color);
          display: flex;
          flex-direction: column;
        }

        .custom-navbar {
          background: var(--card-color);
          border-bottom: 1px solid var(--border-color);
          padding-top: 16px;
          padding-bottom: 16px;
        }

        .music-logo {
          width: 60px;
          height: 60px;
          border-radius: 18px;
          object-fit: cover;
        }

        .brand-title {
          font-size: 28px;
          font-weight: 700;
          color: var(--text-color);
        }

        .brand-subtitle {
          font-size: 14px;
          color: var(--secondary-text);
        }

        .custom-link {
          color: var(--secondary-text) !important;
          transition: 0.3s;
          font-size: 16px;
        }

        .custom-link:hover {
          color: var(--accent-color) !important;
        }

        .body-section {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 80px 20px;
        }

        .empty-body-box {
          background: var(--card-color);
          border: 1px solid var(--border-color);
          border-radius: 32px;
          padding: 60px 30px;
          max-width: 700px;
          margin: auto;
        }

        .body-logo {
          width: 140px;
          height: 140px;
          border-radius: 32px;
          margin-bottom: 30px;
        }

        .body-title {
          font-size: 56px;
          font-weight: 800;
          margin-bottom: 20px;
        }

        .body-text {
          color: var(--secondary-text);
          font-size: 20px;
          line-height: 1.8;
        }

        .footer-section {
          background: var(--card-color);
          border-top: 1px solid var(--border-color);
          padding: 70px 0 30px;
        }

        .footer-logo {
          width: 60px;
          height: 60px;
          border-radius: 18px;
        }

        .footer-title {
          font-size: 28px;
          font-weight: 700;
        }

        .footer-subtitle {
          color: var(--secondary-text);
          font-size: 14px;
        }

        .footer-description {
          color: var(--secondary-text);
          line-height: 1.8;
          font-size: 16px;
        }

        .footer-heading {
          font-size: 24px;
          margin-bottom: 24px;
          font-weight: 700;
        }

        .footer-links,
        .footer-contact {
          list-style: none;
          padding: 0;
        }

        .footer-links li,
        .footer-contact li {
          margin-bottom: 16px;
          color: var(--secondary-text);
        }

        .footer-links a {
          color: var(--secondary-text);
          text-decoration: none;
          transition: 0.3s;
        }

        .footer-links a:hover {
          color: var(--accent-color);
        }

        .copyright-area {
          border-top: 1px solid var(--border-color);
          margin-top: 50px;
          padding-top: 24px;
          text-align: center;
          color: var(--secondary-text);
          font-size: 15px;
        }

        @media (max-width: 991px) {

          .brand-title {
            font-size: 24px;
          }

          .body-title {
            font-size: 42px;
          }

          .body-text {
            font-size: 18px;
          }

        }

        @media (max-width: 576px) {

          .music-logo,
          .footer-logo {
            width: 50px;
            height: 50px;
          }

          .body-logo {
            width: 110px;
            height: 110px;
          }

          .brand-title {
            font-size: 20px;
          }

          .body-title {
            font-size: 34px;
          }

          .body-text {
            font-size: 16px;
          }

          .empty-body-box {
            padding: 40px 20px;
          }

        }

      `}</style>

    </div>
  )
}

export default MusicPlayer